import React from 'react';

import { EditableText } from '@blueprintjs/core';

import { getErrorIntent } from './utils';

const InlineTextArea = ({
  fieldKey,
  formField,
  readOnly,
  placeHolder,
  label,
  fieldHelpers,
  fieldMeta,
}) => {
  const intent = getErrorIntent(fieldMeta);
  return (
    <EditableText
      id={fieldKey}
      intent={intent}
      onConfirm={(value) => {
        if (value !== null) {
          fieldHelpers.setTouched(true, false);
          fieldHelpers.setValue(value, true);
        }
      }}
      placeholder={placeHolder || label}
      defaultValue={formField.value || ''}
      disabled={readOnly}
      multiline={true}
      confirmOnEnterKey={true}
      minLines={3}
      type="text"
    />
  );
};

export default {
  name: 'Inline Text Area',
  options: [],
  decorators: {
    label: false,
  },
  Component: InlineTextArea,
};
